<template>
	<div class="session-wrapper">
		<div class="session-right text-xs-center">
			<div class="session-table-cell">
				<div class="session-content">
					<img
						:src="appLogo"
						class="img-responsive mb-4"
						style="max-width: 300px;"
					/>
					<h2 class="mb-3">{{$t('lang.resetPassword')}}</h2>
					<p class="fs-14">{{$t('lang.pleaseEnterYourPasswordToReset')}}</p>
					<v-form v-model="validPassword" ref="passwordForm" class="mb-4" lazy-validation>
                        <bc-password-input
                            v-model="update_password.password"
                            :label="$t('lang.password')"
                            :counter="showCounter(update_password.password, 'update_password.password')"
							:rules="ifValid('update_password.password')"
                        ></bc-password-input>
                        <bc-password-input
                            v-model="confirm_password"
                            :label="$t('lang.confirm_password')"
                            :counter="showCounter(confirm_password, 'update_password.confirm_password')"
                            :rules="ifValid('update_password.confirm_password')"
                        ></bc-password-input>
						<v-btn large @mouseup.left="changePassword()" block color="primary">{{$t('lang.resetPassword')}}</v-btn>
                        <div>
                            <router-link to="/session/login">{{ $t('lang.backToSignIn') }}</router-link>
                        </div>
					</v-form>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState } from "vuex";
import AppConfig from "Constants/AppConfig";

export default {
    data() {
        return {
            update_password: {
                password: ""
            },
            confirm_password: "",
            validPassword: false,
            forgotten_code: '',
            appLogo: AppConfig.appLogo2
        };
    },
    computed: {
        ...mapState({
            rules_update_password: state => state.validation.rules_update_password,
        }),
    },
    mounted: function() {
        this.reset_code = this.$route.params.id;
        this.checkResetCode();
    },
    methods: {
        checkResetCode() {
            this.startLoader();
            this.$store.dispatch(
                "checkForgotCode",
                {
                    body: this.reset_code
                }
            ).then((data) => {
                this.finishLoader();
            });
        },
        changePassword() {
                this.$nextTick(() => {
                    if (this.validateForm('passwordForm')) {
                        this.startLoader();
                        this.$store.dispatch(
                            "setNewPassword",
                            {
                                url: 'authenticate/reset_password/' + this.reset_code,
                                method: 'post',
                                body: this.update_password
                            }
                        ).then((data) => {
                            this.finishLoader();
                            if (typeof (data) !== "undefined") {
                                this.$router.push("/session/login");
                            }
                        })
                    }
                })
            }
    }
};
</script>
